import { ApiError } from '../../lib/api';

/**
 * One grid template for the header and every row, so the columns line up on a
 * laptop. On a phone the same cells stack into a card (see the `order` classes
 * in `DashboardRow`): name and letter on top, the wine below, then the status
 * controls.
 */
export const DASHBOARD_GRID =
  'md:grid-cols-[1.25rem_minmax(9rem,1.1fr)_10.5rem_minmax(12rem,2.2fr)_7rem_5.5rem_auto]';

/**
 * The route itself missing (a server older than the page) answers with a bare
 * 404, unlike a real "registration not found", which says what wasn't found.
 */
const isMissingRoute = (e: ApiError) =>
  e.status === 404 && (e.message === 'Not found' || e.message.startsWith('Route '));

export const errorMessage = (e: unknown, fallback: string) =>
  e instanceof ApiError
    ? isMissingRoute(e)
      ? `${fallback}: this server doesn't support that yet.`
      : e.message
    : fallback;
